import { SectionTitleAndSubtitle } from "@/components/SectionTitleAndSubtitle";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import GavelIcon from "@mui/icons-material/Gavel";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const services = [
  {
    title: "Auditoria Tributária",
    description:
      "Analisamos detalhadamente os cadastros de produtos e operações da sua empresa para identificar inconsistências tributárias que possam gerar custos indevidos e fazemos toda correção.",
    icon: <ContentPasteSearchIcon fontSize="large" color="primary" />,
  },
  {
    title: "Monitoramento Tributário",
    description:
      "Acompanhamos mensalmente os impostos pagos para identificar valores cobrados a maior e aplicar reduções imediatas, evitando desperdícios e garantindo conformidade fiscal.",
    icon: <TrendingUpIcon fontSize="large" color="primary" />,
  },
  {
    title: "Recuperação Tributária",
    description:
      "Recuperamos valores de tributos pagos indevidamente de forma totalmente administrativa, com segurança jurídica e sem riscos para sua empresa.",
    icon: <GavelIcon fontSize="large" color="primary" />,
  },
  {
    title: "Monitoramento Tributário de Produtos",
    description:
      "Realizamos o acompanhamento mensal dos cadastros de mercadorias e das regras fiscais aplicáveis, garantindo que cada produto esteja corretamente classificado e tributado. Assim, sua empresa evita pagamentos indevidos de impostos e mantém a conformidade tributária de forma contínua.",
    icon: <FindInPageIcon fontSize="large" color="primary" />,
  },
];

export function OurSolutionsSection() {
  return (
    <Box sx={{ backgroundColor: "#f5f7fa", padding: "64px 0" }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "center" },
            alignItems: { xs: "center", md: "center" },
            textAlign: { xs: "center", md: "center" },
          }}
        >
          <Box
            sx={{
              flex: 1,
              marginRight: { xs: "0", md: "32px" },
              marginBottom: { xs: "32px", md: "0" },
            }}
          >
            <Typography variant="subtitle1" color="text.secondary" sx={{ textTransform: "uppercase", fontWeight: 600 }}>
              Por que nos escolher?
            </Typography>
            <SectionTitleAndSubtitle title="Confira nossas soluções" />
            <Typography variant="body1" sx={{ mt: "16px", mb: "32px", maxWidth: { xs: "100%", md: "500px" } }}>
              Identificamos e recuperamos valores de tributos pagos indevidamente, garantindo segurança jurídica e
              maximizando a saúde financeira da sua empresa.
            </Typography>
          </Box>

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              {services.map((service, index) => (
                <Grid key={index} size={{ xs: 12, sm: 6 }}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      padding: "32px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
                      height: "100%",
                    }}
                  >
                    <CardMedia sx={{ display: "flex", justifyContent: "center", mb: "16px" }}>{service.icon}</CardMedia>
                    <CardContent sx={{ padding: "0 !important" }}>
                      <Typography variant="h6" component="h2" sx={{ fontWeight: 600, marginBottom: "8px" }}>
                        {service.title}
                      </Typography>
                      <Typography variant="body2">{service.description}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
